import type { ReactNode } from "react";
import { Platform } from "react-native";
import Svg from "react-native-svg";

import { tokens } from "@/theme/tokens";

export type IconProps = {
  /** A token colour value, e.g. `theme.color.text`. */
  color: string;
  /** One of `tokens.size.icon`; defaults to md (20). */
  size?: (typeof tokens.size.icon)[keyof typeof tokens.size.icon];
  testID?: string;
};

// Hidden from assistive tech: the web takes aria-hidden; Android takes the native props.
const hidden =
  Platform.OS === "web"
    ? { "aria-hidden": true }
    : {
        accessible: false,
        importantForAccessibility: "no-hide-descendants" as const,
      };

/**
 * Line icon frame (design tokens: stroke 1.8, round caps and joins, 24-unit grid). Icons are
 * decorative: the control that holds one carries the accessible label (FR-044).
 */
export function LineIcon({
  color,
  size = tokens.size.icon.md,
  testID,
  children,
}: IconProps & { children: ReactNode }) {
  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={tokens.size.iconStroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      testID={testID}
      {...hidden}
    >
      {children}
    </Svg>
  );
}
